/**
 * Airship caps template variable keys at 32 characters, and {{key}}
 * references inside template content break on characters outside
 * [a-zA-Z0-9_].
 */
export const AIRSHIP_VARIABLE_KEY_MAX_LENGTH = 32;

export function toAirshipVariableKey(variableName: string): string {
  return variableName
    .replace(/[^a-zA-Z0-9_]/g, "_")
    .slice(0, AIRSHIP_VARIABLE_KEY_MAX_LENGTH);
}
